// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1SKTn","clinicsSelect":"TableHeading_clinicsSelect__2NxBE"};